<template>
  <div v-if="state == availStates.START && !isMobile" class="columns">
    <div class="column is-8 is-10-mobile">
      <div class="field is-grouped">
        <p class="control">
          <button class="button is-medium is-primary" @click="startSign(false)">
            Mobilt BankID
          </button>
        </p>
      </div>
      <div class="field is-grouped">
        <p class="control">
          <button class="button is-medium is-primary" @click="startSign(true)">
            BankID på den här datorn
          </button>
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="state == availStates.START && isMobile" class="columns">
    <div class="column is-8 is-10-mobile">
      <div class="field is-grouped">
        <p class="control">
          <button
            class="button is-medium is-primary is-fullwidth"
            @click="startSign(true)"
          >
            BankID på den här enheten
          </button>
        </p>
      </div>
      <div class="field is-grouped">
        <p class="control">
          <button
            class="button is-medium is-primary is-fullwidth"
            @click="startSign(false)"
          >
            BankID på en annan enhet
          </button>
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="state == availStates.PENDING">
    <div class="progress"></div>
    <div class="info-box">
      <div class="columns">
        <div class="column is-8 is-offset-2 is-10-mobile is-offset-1-mobile">
          <a class="bankid-text" :href="autoStartTokenUrl"
            ><span class="icon"><img src="@/assets/bankid.svg"/></span>
            <span>{{ message }}</span></a
          >
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="state == availStates.PENDING_SHOW_QR">
    <div class="progress"></div>
    <div class="info-box">
      <div class="columns">
        <div class="column is-8 is-offset-2 is-10-mobile is-offset-1-mobile">
          <span class="bankid-text"
            ><span class="icon"><img src="@/assets/bankid.svg"/></span>
            <span>{{ message }}</span></span
          >
        </div>
      </div>
      <div class="columns">
        <div
          class="has-text-centered column is-8 is-offset-2 is-10-mobile is-offset-1-mobile"
        >
          <img :src="autoStartTokenQrImage" />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="state == availStates.FAILED" class="columns">
    <div class="column is-8 is-10-mobile">
      <b-message title="Fel vid Signering" type="is-danger" :closable="false">
        {{ message }}
      </b-message>
    </div>
  </div>
  <div v-else-if="state == availStates.SUCCESS" class="columns">
    <div class="column is-8 is-10-mobile">
      <b-message title="Signerad" type="is-success" :closable="false">
        {{ message }}
      </b-message>
    </div>
  </div>
</template>

<script>
import isMobile from 'is-mobile'

export default {
  name: 'bank-id-sign',
  props: {
    debug: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: isMobile({ ua: navigator.userAgent, tablet: true })
    },
    collectInterval: {
      type: Number,
      default: 2000
    },
    userVisibleData: {
      type: String,
      default: ''
    },
    userNonVisibleData: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMobile: this.mobile
    }
  },
  mounted() {
    this.$store.commit('setState', this.availStates.IDLE) // Reset state to IDLE
  },
  computed: {
    availStates: function() {
      return this.$store.state.session.availStates
    },
    state: function() {
      return this.$store.state.session.authState
    },
    message: function() {
      return this.$store.state.session.message
    },
    autoStartToken: function() {
      return this.$store.state.session.autoStartToken
    },
    autoStartTokenUrl: function() {
      return this.$store.state.session.autoStartTokenUrl
    },
    autoStartTokenQrImage: function() {
      return this.$store.state.session.autoStartTokenQrImage
    }
  },
  methods: {
    startSign(thisDevice) {
      this.$store.dispatch('startSign', {
        thisDevice,
        debug: this.debug,
        mobile: this.mobile,
        collectInterval: this.collectInterval,
        userVisibleData: this.userVisibleData,
        userNonVisibleData: this.userNonVisibleData
      })
    }
  },
  watch: {
    autoStartTokenUrl() {
      if (this.state === this.availStates.PENDING && this.autoStartTokenUrl) {
        window.open(this.autoStartTokenUrl, '_blank')
      }
    },
    '$store.getters.isLoggedIn'(newState, oldState) {
      if (this.$store.getters.isLoggedIn && !this.debug) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped lang="scss">
$deep-sapphire: #012169;
$lochmara: #0085ca;
.is-bankid-field {
  position: relative;
  label {
    position: absolute;
    top: 20px;
    left: 14px;
    z-index: 90;
    font-size: 1.2rem;
    margin: 0;
    pointer-events: none;
    transform-origin: top left;
    transition: transform 150ms ease;
    font-weight: 400;
  }
  &.has-input {
    label {
      transform: scale(0.65) translateY(-15px);
    }
  }
  input {
    padding: 1.6rem 0.8rem 0.8rem 0.8rem;
    height: auto;
    font-size: 1.2rem;
    &::-ms-clear {
      display: none;
    }
  }
  .icon {
    width: 2.85em;
    height: 100%;
    &.is-right {
      right: 5px;
    }
  }
}
.icon-bankid {
  height: 1.5rem;
}

.button.is-fullwidth {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  height: auto;
}
.control .button.is-primary {
  background-color: $deep-sapphire;
}

.progress {
  height: 1rem;
  width: 100%;
  background: #333;
  border-radius: 0px;
  background: radial-gradient(
      circle at center,
      $lochmara 0,
      $deep-sapphire 100%
    )
    repeat center center;
  margin-bottom: 0px;
  animation: progress 5s linear infinite;
  @media screen and (max-width: 768px) {
    animation: progress-full-width 5s linear infinite;
  }
}
.info-box {
  padding: 3rem 0;
  background: #f6fcff;
  .bankid-text {
    color: $deep-sapphire;
    display: flex;
    align-items: center;
    font-weight: 800;
    font-size: 0.9rem;
    span {
      font-family: 'Nexa', sans-serif;
    }
    .icon {
      margin-right: 0.7rem;
      width: 2em;
      height: 2em;
    }
  }
}
@keyframes progress {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 50vw 0;
  }
}
@keyframes progress-full-width {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 100vw 0;
  }
}
</style>
